import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

type CircleIconProps = {
  fill: string
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`

export const CircleIcon = styled.div<CircleIconProps>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ fill }) => fill};
`

export const LabelText = styled.span`
  font-size: ${theme.typography.sizes['2xs']};
  font-weight: ${theme.typography.weight.xl};
  color: ${theme.colors.neutral.medium};
`
